import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';

<meta name="google" value="notranslate"></meta>
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(

  <App />

);


